import React, { useEffect, useRef } from 'react';

// Shared add/edit dialog for the admin pages. An inline form at the top of a long page opens
// off-screen from wherever the admin clicked, so these open over the page instead. Esc or the
// close button cancels; clicking the backdrop deliberately does not, so a stray click can't
// discard a half-typed form. The form is a real <form>, so Enter submits.
const AdminModal = ({
  title, badge, onClose, onSubmit, error, saving, saveLabel = 'Save', size = 'md', children,
}) => {
  const closeRef = useRef(onClose);
  closeRef.current = onClose;

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') closeRef.current(); };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, []);

  return (
    <div className="admin-modal-overlay" role="dialog" aria-modal="true" aria-label={title}>
      <form
        className={`admin-modal admin-modal-${size}`}
        onSubmit={e => { e.preventDefault(); onSubmit(); }}
      >
        <div className="admin-modal-header">
          <h3>{title} {badge && <span className="admin-modal-badge">{badge}</span>}</h3>
          <button type="button" className="admin-modal-close" onClick={onClose} aria-label="Close">&times;</button>
        </div>
        {error && <div className="error-banner">{error}</div>}
        <div className="admin-modal-body">{children}</div>
        <div className="form-actions admin-modal-actions">
          <button type="submit" className="btn-primary" disabled={saving}>{saving ? 'Saving…' : saveLabel}</button>
          <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
        </div>
      </form>
    </div>
  );
};

export default AdminModal;
